import React from 'react'

export const Loading: React.FC = () => {
  return (
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
  )
}